import { OnInit, OnDestroy } from '@angular/core';
import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { RdsModule } from '@rabobank/rds-angular';
import { BatchService } from '../../services/batch.service';
import { Subject, takeUntil, filter } from 'rxjs';
import { InteractionStatus } from '@azure/msal-browser';

@Component({
  selector: 'app-welcome',
  imports: [RdsModule],
  templateUrl: './welcome.component.html',
  styleUrl: './welcome.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class WelcomeComponent implements OnInit, OnDestroy {

  public userName: string = '';
  private readonly _destroy = new Subject<void>();

  constructor(
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private sharedService: BatchService
  ) {}

  public ngOnInit(): void {
    // Listen for MSAL interaction status
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroy)
      )
      .subscribe(() => {
        this.updateUserName();
      });

    // Subscribe to login status changes
    this.sharedService.isUserLoggedIn
      .pipe(takeUntil(this._destroy))
      .subscribe(isLoggedIn => {
        if (isLoggedIn) {
          this.updateUserName();
        } else {
          this.userName = '';
        }
      });

    // Initial check
    this.updateUserName();
  }

  private updateUserName(): void {
    let account = this.msalService.instance.getActiveAccount();
    if (!account) {
      const accounts = this.msalService.instance.getAllAccounts();
      if (accounts.length > 0) {
        this.msalService.instance.setActiveAccount(accounts[0]);
        account = accounts[0];
      }
    }

    this.userName = account ? this.formatName(account.name || '') : '';
  }

  private formatName(rawName: string): string {
    const name = (rawName || '').trim();
    if (!name) return '';
    // Pattern for format 1: capture Last and the parenthesized First
    const parenMatch = name.match(/^\s*([^,()]+),\s*[^()]*\(\s*([^)]+)\s*\)\s*$/);
    if (parenMatch) {
      const last = parenMatch[1].trim();
      const first = parenMatch[2].trim();
      return `${first}`;
    }
    // Pattern for format 2: "Last, First"
    const commaMatch = name.match(/^\s*([^,]+),\s*(.+)\s*$/);
    if (commaMatch) {
      const last = commaMatch[1].trim();
      const first = commaMatch[2].trim();
      return `${first.split(' ')[0]}`;
    }
    // Fallback: return only the first token (first name) to avoid long headings
    return name.split(' ')[0];
  }

  public ngOnDestroy(): void {
    this._destroy.next();
    this._destroy.complete();
  }

}
